import { makeObservable, observable, transaction } from "mobx"
import { BaseStore } from "stores/base.store"
import { RootStore } from "stores/root.store"
import {
  createMarketplaceCohort,
  CreateCohortInput,
  deleteMarketplaceCohort,
  IMarketplaceCohort,
  listMarketplaceCohorts,
  updateMarketplaceCohort,
  UpdateCohortInput,
} from "../api/marketplace-cohorts.call"

export class MarketplaceCohortsStore extends BaseStore {
  @observable
  public items: IMarketplaceCohort[] = []

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  async load(): Promise<void> {
    const res = await this.defaultFunction(listMarketplaceCohorts)
    if (res && !this.showErrorNotifications(res)) {
      transaction(() => {
        this.items = res
      })
    }
  }

  async create(input: CreateCohortInput): Promise<IMarketplaceCohort | undefined> {
    return this.defaultFunction(createMarketplaceCohort, input)
  }

  async update(id: string, input: UpdateCohortInput): Promise<IMarketplaceCohort | undefined> {
    return this.defaultFunction(updateMarketplaceCohort, id, input)
  }

  async remove(id: string): Promise<void> {
    await this.defaultFunction(deleteMarketplaceCohort, id)
  }
}
